import { render, staticRenderFns } from "./ViewTenantDetails.vue?vue&type=template&id=7b3636be&"
import script from "./ViewTenantDetails.vue?vue&type=script&lang=js&"
export * from "./ViewTenantDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports